export { CardDetailsTileLink, type CardDetailsTileLinkProps } from "#card-details-tile-link";
